import {Button} from '@/components/common-components/v2/Button';
import {faImage} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Tooltip} from 'antd';
import styles from '../../style.module.scss';
import styled from 'styled-components';


interface Props {
  openDrawer: (value: boolean) => void;
}

export const AddImage = ({openDrawer}: Props) => {
  const onAddImage = () => {
    openDrawer(true);
  };

  return <Tooltip title='Search and insert images into the article.'>
    <ButtonStyled
      mode='light'
      color='white'
      style={{display: 'flex', marginRight: 10, color: '#4E5156', padding: '0 5px'}}
      onClick={onAddImage}
      className={styles.share}
    >
      <FontAwesomeIcon color='#243F68' icon={faImage} style={{marginRight: '5px', height: '14px'}} className={styles.robotIcon} />
      <span className={styles.shareBtnLabel}>
      AI Image Creator
      </span>
    </ButtonStyled>
  </Tooltip>;
};

const ButtonStyled = styled(Button)`
  color: #4E5156;
  background-color: RGBA(36,63,104,0.15);
  padding: 5px 10px !important;
  margin-top: -3px;
`;
